var React = require('react');

function QuoteTop (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.7,30.64,19.92,35H31.05L25.62,60H0L6,32.43Q9.58,15.83,16.82,8.68,24.32,1.27,38.29,0L35.71,13.53c-4.32.68-7.59,2.3-9.84,4.85S21.91,25,20.7,30.64ZM74,0,71.41,13.53q-6.47,1-9.83,4.85T56.41,30.64L55.63,35H66.76L61.32,60H35.71l5.95-27.57q3.62-16.6,10.86-23.75Q60,1.27,74,0Z"}));
}

QuoteTop.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 74 60"};

module.exports = QuoteTop;

QuoteTop.default = QuoteTop;
